<template>
  <div class='toggle'>
    <p v-text='(toggle.nickName.length <= 0) ? "Unknown" : toggle.nickName'></p>
    <div class='item'>
      <input v-bind:id='toggle.instanceGuid' type='checkbox' v-model='value' />
      <label v-bind:for='toggle.instanceGuid'></label>
    </div>
  </div>
</template>

<script>

import UIBase from './UIBase.vue';

export default {
  name: 'Toggle',
  extends: UIBase,
  components: {
  },
  props: {
    toggle: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    value: {
      get () {
        return this.toggle.value;
      },
      set (v) {
        if (this.toggle.value !== v) {
          this.toggle.change(v);
        }
      }
    }
  },
  data () {
    return {
    };
  },
  mounted () {
  }
};

</script>



// WEBPACK FOOTER //
// src/components/Toggle.vue